module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/spot02_american-village-f122824ea797971c260da001546f43e3.jpg";